export default __webpack_public_path__ + "static/media/nic_logo_dark.d98c9ebb.svg";